import { render, staticRenderFns } from "./cardifao.vue?vue&type=template&id=00dc0bb1&scoped=true"
import script from "./cardifao.vue?vue&type=script&lang=ts"
export * from "./cardifao.vue?vue&type=script&lang=ts"
import style0 from "./cardifao.vue?vue&type=style&index=0&id=00dc0bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc0bb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol})
